<form [formGroup]="mainForm" *ngIf="mainForm">
  <quill-editor class="quillEditor" [ngClass]="{'quillEditor-error': (control && control.errors)}"
    [formControlName]="controlName" [sanitize]="true" [placeholder]="''"
    [valueGetter]="valueGetter" (onEditorCreated)="onEditorCreated($event)">

    <div quill-editor-toolbar>
      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-list" type="button" value="ordered"></button>
        <button class="ql-list" type="button" value="bullet"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-indent" value="-1"></button>
        <button class="ql-indent" value="+1"></button>
      </span>
    </div>

  </quill-editor>
  <app-form-errors [control]="control"></app-form-errors>
</form>
